let n = 0;

const cameForThe = [
    "Use my skills and grow these further",
    "A friend of mine asked if I would like to apply",
    "Wanted to work for a startup",
    "We are experiencing a shift in freelancing and Xolo is going to be a front-runner!",
    "I was intrigued by the idea that we can solve a real problem on a global scale",
    "My former colleague recommended Xolo",
    "My last company was in… a very uncertain state at the time",
    "Opportunity to develop a product that makes sense",
    "Timing and luck",
    "I was referred by a former employee and I liked the mission",
    "I wanted to join a startup",
    "The people, the mission, the vibe",
    "I love accounting",
    "The people doing the job get to decide how the job gets done.",
    "The opportunity was different than just a job as an accountant",
    "I read an article about Maarja-Liis' location-independent job at Xolo",
    "I wanted to experience working for a startup",
    "I can be part of this service that helps so many solopreneurs",
    "Jane recommended Xolo and I trust her",
    "To find new challenges and develop new skills",
    "I am a solopreneur too so with Xolo I feel like I am building a better world for myself"
];

let stayedForThe = [
    "Still the same reasons",
    "The company atmosphere",
    "When I started we had one product. Look at us now!",
    "It challenges me and allows me to do what I'm passionate about. Remote work option doesn't hurt either.",
    "The people and the endless opportunities to remove paperwork and beaurocracy from daily life.",
    "Love the atmosphere, the people and the remote option!",
    "People. There hasn't been a dull day since I started. ",
    "To make solopreneurship a magical experience!",
    "I love the people and the challenges",
    "The people, the mission and the freedom",
    "I have found one of my best friends here!",
    "The people, the vibe, the mission",
    "I like my job, my colleagues and my clients",
    "People at Xolo are appreciated and valued.",
    "I still like my job and my colleagues",
    "The an option to work as a freelancer, part-time and/or remotely keeps me motivated",
    "Opportunity to challenge myself",
    "Friendly team, good work environment",
    "I feel valued and supported; strong team spirit; remote work; transparent & open communication; friends",
    "New challanges keep me motivated",
    "Because above hasn't changed"
];

document.addEventListener("DOMContentLoaded", () => {
    const button = document.querySelector(".change-text");
    button.addEventListener("click", changeTextFields);
});

const changeTextFields = () => {
    n++;
    $("#text-came-for-the, #text-stayed-for-the").fadeOut("slow", () => {
        document.querySelector("#text-came-for-the").innerHTML = cameForThe[n];
        document.querySelector("#text-stayed-for-the").innerHTML = stayedForThe[n];
        $("#text-came-for-the, #text-stayed-for-the").fadeIn("slow");
        if (n >= stayedForThe.length) {
            n = 0;
        }
    });
};
